import actionTypes from './actionTypes';

const DEFAULT_STATE = {
  adsList: [],
  adsListLoading: false,
  adsListFailed: false,
  adsListReject: false,
  adsListFailedMassage: null,

  addOrEditAdLoading: false,
  addPrEditAdError: false,
  addOrEditAdFailed: false,
  addOrEditAdFailedMessages: []
};

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_ADS_LIST_LOADING: {
      return {
        ...state,
        adsList: [],
        adsListLoading: true,
        adsListFailed: false,
        adsListReject: false,
        adsListFailedMassage: null
      };
    }
    case actionTypes.GET_ADS_LIST_SUCCESS: {
      return {
        ...state,
        adsList: action.payload.ads,
        adsListLoading: false,
        adsListFailed: false,
        adsListReject: false
      };
    }
    case actionTypes.GET_ADS_LIST_FAILED: {
      return {
        ...state,
        adsList: [],
        adsListLoading: false,
        adsListFailed: true,
        adsListFailedMassage: action.payload.message,
        adsListReject: false
      };
    }
    case actionTypes.GET_ADS_LIST_REJECT: {
      return {
        ...state,
        adsList: [],
        adsListLoading: false,
        adsListFailed: false,
        adsListReject: true
      };
    }
    case actionTypes.CHANGE_AD_VISIBILITY_LOADING: {
      return {
        ...state,
        adsListLoading: true,
        adsListFailed: false,
        adsListReject: false
      };
    }
    case actionTypes.CHANGE_AD_VISIBILITY_SUCCESS: {
      const modifiedAdsList = [...state.adsList];
      const ix = modifiedAdsList.findIndex(ad => ad.id === action.payload.id);

      if (ix >= 0) {
        modifiedAdsList[ix] = {
          ...modifiedAdsList[ix],
          isVisible: action.payload.isVisible
        };
      }

      return {
        ...state,
        adsList: modifiedAdsList,
        adsListLoading: false,
        adsListFailed: false,
        adsListReject: false
      };
    }
    case actionTypes.CHANGE_AD_VISIBILITY_FAILED: {
      return {
        ...state,
        adsListLoading: false,
        adsListFailed: true,
        adsListReject: false
      };
    }
    case actionTypes.CHANGE_AD_VISIBILITY_REJECT: {
      return {
        ...state,
        adsListLoading: false,
        adsListFailed: false,
        adsListReject: true
      };
    }
    case actionTypes.DELETE_AD_LOADING: {
      return {
        ...state,
        adsListLoading: true,
        adsListFailed: false,
        adsListReject: false
      };
    }
    case actionTypes.DELETE_AD_SUCCESS: {
      const modifiedAdsList = state.adsList.filter(ad => ad.id !== action.payload.id);

      return {
        ...state,
        adsList: modifiedAdsList,
        adsListLoading: false,
        adsListFailed: false,
        adsListReject: false
      };
    }
    case actionTypes.DELETE_AD_FAILED: {
      return {
        ...state,
        adsListLoading: false,
        adsListFailed: true,
        adsListReject: false
      };
    }
    case actionTypes.DELETE_AD_REJECT: {
      return {
        ...state,
        adsListLoading: false,
        adsListFailed: false,
        adsListReject: true
      };
    }

    case actionTypes.DEFAULT_AD_LOADING: {
      return {
        ...state,
        adsListLoading: true,
        adsListFailed: false,
        adsListReject: false
      };
    }
    case actionTypes.DEFAULT_AD_SUCCESS: {
      const modifiedAdsList = [...state.adsList];
      const ix = modifiedAdsList.findIndex(ad => ad.id === action.payload.ad.id);

      if (ix >= 0) {
        modifiedAdsList[ix] = {
          ...modifiedAdsList[ix],
          isDefault: action.payload.ad.isDefault
        };
      }
      return {
        ...state,
        adsList: modifiedAdsList,
        adsListLoading: false,
        adsListFailed: false,
        adsListReject: false
      };
    }
    case actionTypes.DEFAULT_AD_FAILED: {
      return {
        ...state,
        adsListLoading: false,
        adsListFailed: true,
        adsListReject: false
      };
    }
    case actionTypes.DEFAULT_AD_REJECT: {
      return {
        ...state,
        adsListLoading: false,
        adsListFailed: false,
        adsListReject: true
      };
    }
    default:
      return state;
  }
};
